import type { ButtonHTMLAttributes } from "react";
import { cn } from "../../lib/utils.js";

export type ToggleGroupProps = {
  value: string;
  onChange: (value: string) => void;
  options: ReadonlyArray<{ value: string; label: string }>;
  className?: string;
};

export const ToggleGroup = ({ value, onChange, options, className }: ToggleGroupProps) => (
  <div
    className={cn(
      "inline-flex h-9 items-center justify-center rounded-lg bg-muted p-1 text-muted-foreground",
      className
    )}
    role="group"
  >
    {options.map((option) => (
      <ToggleGroupItem
        key={option.value}
        pressed={value === option.value}
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </ToggleGroupItem>
    ))}
  </div>
);

type ToggleGroupItemProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  pressed?: boolean;
};

const ToggleGroupItem = ({ className, pressed, ...props }: ToggleGroupItemProps) => (
  <button
    type="button"
    className={cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
      pressed ? "bg-background text-foreground shadow" : "hover:text-foreground",
      className
    )}
    aria-pressed={pressed}
    {...props}
  />
);
